import { Typography, useTheme } from '@mui/material';

export const ZeroCountGridCell = () => {
  const theme = useTheme();

  return <Typography color={`${theme.colors.primary.dark}`}>0</Typography>;
};
